import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
export default function SelectFilter(_ref) {
  let {
    initialValue = '',
    onFilter,
    options,
    ...props
  } = _ref;
  const [value, setValue] = useState(initialValue);
  const {
    t
  } = useTranslation();
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);
  return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement(Form.Control, {
    as: "select",
    value: value,
    onChange: e => {
      setValue(e.target.value);
      onFilter(e.target.value);
    },
    onClick: e => {
      e.preventDefault();
      e.stopPropagation();
    },
    placeholder: "Select"
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, t('all')), options.map(option => /*#__PURE__*/React.createElement("option", {
    value: option
  }, t(option)))));
}